import { render, staticRenderFns } from "./TransitionType.vue?vue&type=template&id=3b32cf09&scoped=true&"
import script from "./TransitionType.vue?vue&type=script&lang=js&"
export * from "./TransitionType.vue?vue&type=script&lang=js&"
import style0 from "./TransitionType.vue?vue&type=style&index=0&id=3b32cf09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32cf09",
  null
  
)

export default component.exports